import { Link } from 'react-router-dom';
import type { MenteeDashboardMentor } from './MenteePortalService';
import { initialsFromName, joinPresent } from '../mentorDashboardFormat';

type Props = {
    mentor: MenteeDashboardMentor | null;
};

const MenteeDashboardMentorCard = ({ mentor }: Props) => {
    if (!mentor) {
        return null;
    }

    if ('status' in mentor && mentor.status === 'yet_to_be_assigned') {
        return (
            <aside className="mdash-mentor-card">
                <p className="mdash-mentor-label">Your mentor</p>
                <p className="mdash-mentor-unassigned">{mentor.label || 'Mentor Yet to be assigned'}</p>
            </aside>
        );
    }

    const paired = mentor as Exclude<MenteeDashboardMentor, { status: 'yet_to_be_assigned' }>;
    const roleLine = joinPresent([paired.designation, paired.company]);

    return (
        <div className="col-lg-4 mt-3 mt-lg-0">
            <div className="card border-0 bg-white bg-opacity-10 text-white rounded-3 shadow-sm p-3 text-center">
                <div className="small fw-semibold text-white-75 text-uppercase tracking-wider mb-2">Your Mentor</div>
                    <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                        {paired.photo ? (
                            <img className="mdash-mentor-photo" src={paired.photo} alt="" />
                                ) : (
                                    <span className="d-flex align-items-center justify-content-center bg-white bg-opacity-10 text-white rounded-circle mx-auto border border-white border-opacity-50 font-600" style={{ width: '45px', height: '45px' }} aria-hidden="true">
                                        {initialsFromName(paired.name)}
                                    </span>
                                )}
                    </div>

                    {paired.name ? <div className="fw-bold font-14 text-capitalize">{paired.name}</div> : null}
                    {roleLine ? <div className="small text-white-75">{roleLine}</div> : null}
                    
                    <Link
                        to="/alumni/mentorship/mentee/mentor"
                        className="btn btn-sm btn-light text-primary fw-bold w-100 mt-2 font-11"
                    >
                        View Profile →
                    </Link>
            </div>
            
            
        </div>
    );
};

export default MenteeDashboardMentorCard;
